import React, { useState, useEffect, useRef } from 'react';
import { scaricaFile } from '../utils/coperturaPdf';

// Pulsante "Apri PDF" per i risultati copertura della PWA agente: il PDF viene APERTO in anteprima
// (nel visualizzatore del telefono), non salvato subito; da li' l'utente decide se condividerlo o
// salvarlo. Se il visualizzatore non si apre (popup bloccato) si mostra l'anteprima nell'app, con
// i pulsanti Condividi/Scarica.
// Il PDF e' pre-generato all'apertura del dialog: window.open e navigator.share DEVONO essere
// chiamati dentro il gesto dell'utente (un await prima li farebbe fallire per "user activation").
const IcoPdf = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><path d="M14 2v6h6" />
  </svg>
);

const puoCondividere = (file) => {
  try { return !!(navigator.canShare && navigator.canShare({ files: [file] })); } catch (e) { return false; }
};

export default function CondividiPdfBtn({ make, titolo = 'Analisi Copertura', className = 'ghost', style }) {
  const [stato, setStato] = useState('prep');   // prep | pronto | errore
  const [condivisibile, setCondivisibile] = useState(false);
  const [anteprima, setAnteprima] = useState(null);   // url blob mostrato dentro l'app (fallback)
  const fileRef = useRef(null);
  const urlRef = useRef(null);

  useEffect(() => {
    let annullato = false;
    setStato('prep'); fileRef.current = null;
    Promise.resolve().then(make).then(f => {
      if (annullato) return;
      fileRef.current = f; setCondivisibile(puoCondividere(f)); setStato('pronto');
    }).catch(() => { if (!annullato) setStato('errore'); });
    return () => { annullato = true; };
  }, [make]);

  // l'url del blob vive quanto il componente: revocarlo subito chiuderebbe l'anteprima appena aperta
  useEffect(() => () => { if (urlRef.current) URL.revokeObjectURL(urlRef.current); }, []);

  const apri = () => {
    const file = fileRef.current;
    if (!file) return;
    if (!urlRef.current) urlRef.current = URL.createObjectURL(file);
    const w = window.open(urlRef.current, '_blank');   // niente await prima: perderebbe l'attivazione utente
    if (!w) setAnteprima(urlRef.current);              // popup bloccato -> anteprima dentro l'app
  };

  const condividi = () => {
    const file = fileRef.current;
    if (!file) return;
    navigator.share({ files: [file], title: titolo, text: "In allegato l'analisi di copertura di rete." })
      .catch(e => { if (!e || e.name !== 'AbortError') scaricaFile(file); });   // annullato = niente; fallito = scarico
  };

  const etichetta = stato === 'prep' ? 'Preparo il PDF…'
    : stato === 'errore' ? 'PDF non disponibile' : 'Apri PDF';

  return (
    <>
      <button className={className} style={style} onClick={apri} disabled={stato !== 'pronto'}>
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}><IcoPdf />{etichetta}</span>
      </button>
      {anteprima && (
        <div className="scrim" onClick={() => setAnteprima(null)}>
          <div className="modal" style={{ width: 'min(560px,96vw)', padding: 12 }} onClick={e => e.stopPropagation()}>
            <iframe title="Anteprima PDF" src={anteprima}
              style={{ width: '100%', height: '62vh', border: '1px solid var(--line-2)', borderRadius: 10, background: '#fff' }} />
            <div className="actions">
              {condivisibile && <button className="ghost" onClick={condividi}>Condividi</button>}
              <button className="ghost" onClick={() => scaricaFile(fileRef.current)}>Salva</button>
              <button className="ghost" onClick={() => setAnteprima(null)}>Chiudi</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
